import { useEffect, useState, useRef } from 'react';
import * as React from 'react';
import CustomIcon from '@components/shared/CustomIcon';
import cn from 'classnames';
import ts from '@styles/typography.module.less';
import s from './SimpleDropdown.module.less';

type Props = {
  children?: React.ReactNode;
  title: string;
  onOpen?: () => void;
};

const SimpleDropdown = ({ title, children, onOpen }: Props) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen(openState => !openState);

  useEffect(() => {
    if (isOpen && onOpen) onOpen();
  }, [isOpen]);

  useEffect(() => {
    const handleOutsideClick = event => {
      if (!dropdownRef?.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  });

  return (
    <div ref={dropdownRef} className={s.dropdownContainer}>
      <div
        className={cn({
          [ts.bodyMediumRegular]: true,
          [s.dropdownButton]: true,
          [s.open]: isOpen,
        })}
        onClick={toggleOpen}
        role="button"
      >
        <span className={s.title}>{title}</span>
        <CustomIcon className={s.icon} type={isOpen ? 'dropdown-up' : 'dropdown-down'} />
      </div>
      {isOpen && <div className={s.dropdown}>{children}</div>}
    </div>
  );
};

export default SimpleDropdown;
